// Edge cases and stress test scenarios for add-ons
export default [
    // Empty article (no content)
    {
        id: '1',
        type: 'article',
        title: '',
        body: '',
        start_page: 1,
        end_page: 1,
        location_in_start_page: { x: '50.0', y: '50.0' },
    },

    // Article with extremely long title
    {
        id: '2',
        type: 'article',
        title: 'This is an extremely long title that goes on and on and on to test how the system handles titles that exceed normal length expectations and might cause layout issues in the add-ons panel when displayed in various screen sizes and orientations particularly on mobile devices where space is limited',
        pretitle: 'ALSO A VERY LONG PRETITLE THAT MIGHT CAUSE ISSUES WITH LAYOUT AND DISPLAY',
        author: 'Author with an extraordinarily long name that includes multiple middle names and suffixes like Dr. Professor Emeritus Sir Alexander Maximilian Constantine Bartholomew Richardson-Smithsonian III, Ph.D., M.D., J.D., MBA, CPA',
        body: '<p>Regular content</p>',
        start_page: 1,
        end_page: 1,
        location_in_start_page: { x: '10.0', y: '10.0' },
    },

    // Article with special characters and emojis
    {
        id: '3',
        type: 'article',
        title: '🚀 Spëcîál Çhárâctérs & Symbols: €$¥£ ™®© → ← ↑ ↓ 中文 العربية עברית 日本語 🎉',
        author: 'José María Gutiérrez-Müller Фёдоров',
        body: '<p>Testing Unicode: 你好世界 مرحبا بالعالم שלום עולם こんにちは世界 🌍🌎🌏</p><p>Math symbols: ∑ ∫ ∂ ∇ ∞ ≈ ≠ ≤ ≥ ± × ÷ √ ∛ ∜</p>',
        start_page: 2,
        end_page: 2,
        location_in_start_page: { x: '25.5', y: '33.3' },
    },

    // Article with malformed HTML
    {
        id: '4',
        type: 'article',
        title: 'Article with Broken HTML',
        body: '<div><p>Unclosed paragraph tag<div>Nested unclosed div<span>Unclosed span</p></div><script>alert("XSS attempt")</script><img src=x onerror="alert(\'XSS\')"><p onclick="alert(\'click\')">Clickable paragraph</p>',
        start_page: 3,
        end_page: 3,
        location_in_start_page: { x: '40.0', y: '40.0' },
    },

    // Article at extreme coordinates
    {
        id: '5',
        type: 'article',
        title: 'Top-left corner (0,0)',
        body: '<p>Testing boundary condition</p>',
        start_page: 4,
        end_page: 4,
        location_in_start_page: { x: '0.0', y: '0.0' },
    },
    {
        id: '6',
        type: 'article',
        title: 'Bottom-right corner (100,100)',
        body: '<p>Testing boundary condition</p>',
        start_page: 4,
        end_page: 4,
        location_in_start_page: { x: '100.0', y: '100.0' },
    },
    {
        id: '7',
        type: 'article',
        title: 'Negative coordinates (should be handled)',
        body: '<p>Testing invalid coordinates</p>',
        start_page: 4,
        end_page: 4,
        location_in_start_page: { x: '-10.0', y: '-10.0' },
    },
    {
        id: '8',
        type: 'article',
        title: 'Coordinates beyond 100',
        body: '<p>Testing invalid coordinates</p>',
        start_page: 4,
        end_page: 4,
        location_in_start_page: { x: '150.0', y: '150.0' },
    },

    // Article with extremely high precision coordinates
    {
        id: '9',
        type: 'article',
        title: 'Ultra-precise positioning',
        body: '<p>Testing floating point precision</p>',
        start_page: 5,
        end_page: 5,
        location_in_start_page: { x: '33.333333333333336', y: '66.666666666666671' },
    },

    // Article spanning many pages
    {
        id: '10',
        type: 'article',
        title: 'Article spanning 43 pages',
        body: '<p>This article spans from page 6 to page 48</p>',
        start_page: 6,
        end_page: 48,
        location_in_start_page: { x: '20.0', y: '20.0' },
        location_in_end_page: { x: '80.0', y: '80.0' },
    },

    // Multiple articles at exact same position (overlapping)
    {
        id: '11',
        type: 'article',
        title: 'Overlapping Article 1',
        body: '<p>First article at this position</p>',
        start_page: 7,
        end_page: 7,
        location_in_start_page: { x: '50.0', y: '50.0' },
    },
    {
        id: '12',
        type: 'article',
        title: 'Overlapping Article 2',
        body: '<p>Second article at exact same position</p>',
        start_page: 7,
        end_page: 7,
        location_in_start_page: { x: '50.0', y: '50.0' },
    },
    {
        id: '13',
        type: 'article',
        title: 'Overlapping Article 3',
        body: '<p>Third article at exact same position</p>',
        start_page: 7,
        end_page: 7,
        location_in_start_page: { x: '50.0', y: '50.0' },
    },

    // Article with null/undefined values
    {
        id: '14',
        type: 'article',
        title: null,
        author: undefined,
        body: null,
        image_url: null,
        start_page: 8,
        end_page: 8,
        location_in_start_page: { x: '30.0', y: '30.0' },
    },

    // Article with missing required fields
    {
        id: '15',
        // Missing type
        title: 'Article missing type field',
        // Missing start_page
        end_page: 9,
        // Missing location
    },

    // Article with wrong data types
    {
        id: '16-string-id',
        type: 123, // Number instead of string
        title: ['Array', 'as', 'title'], // Array instead of string
        body: { text: 'Object as body' }, // Object instead of string
        start_page: '10', // String instead of number
        end_page: '10',
        location_in_start_page: { x: 'not-a-number', y: 'also-not-a-number' },
    },

    // Extremely large content
    {
        id: '17',
        type: 'article',
        title: 'Article with massive content',
        body: `<p>${'Lorem ipsum dolor sit amet. '.repeat(10000)}</p>`, // ~300KB of text
        start_page: 11,
        end_page: 11,
        location_in_start_page: { x: '45.0', y: '45.0' },
        content_metrics: {
            total_number_of_words: 40000,
            reading_time_minutes: 160,
        },
    },

    // Article with circular reference (if parsed from JSON)
    {
        id: '18',
        type: 'article',
        title: 'Article with metadata',
        body: '<p>Testing metadata handling</p>',
        start_page: 12,
        end_page: 12,
        location_in_start_page: { x: '60.0', y: '60.0' },
        metadata: {
            note: 'This object could potentially have circular references in real scenarios',
        },
    },

    // Article with RTL (Right-to-Left) content
    {
        id: '19',
        type: 'article',
        title: 'مقال باللغة العربية',
        author: 'محمد الأحمد',
        body: '<div dir="rtl"><p>هذا نص تجريبي باللغة العربية لاختبار عرض النصوص من اليمين إلى اليسار.</p><p>السطر الثاني من النص العربي.</p></div>',
        start_page: 13,
        end_page: 13,
        location_in_start_page: { x: '70.0', y: '30.0' },
    },

    // Article with mixed LTR and RTL
    {
        id: '20',
        type: 'article',
        title: 'Mixed Direction: English and עברית and العربية',
        body: '<p>This paragraph is in English.</p><p dir="rtl">هذه الفقرة بالعربية.</p><p dir="rtl">פסקה זו בעברית.</p><p>Back to English.</p>',
        start_page: 14,
        end_page: 14,
        location_in_start_page: { x: '35.0', y: '65.0' },
    },

    // Article with base64 encoded image
    {
        id: '21',
        type: 'article',
        title: 'Article with inline base64 image',
        body: '<p>Article with embedded image</p><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==">',
        image_url:
            'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==',
        start_page: 15,
        end_page: 15,
        location_in_start_page: { x: '25.0', y: '75.0' },
    },

    // Article with broken image URL
    {
        id: '22',
        type: 'article',
        title: 'Article with broken image',
        body: '<p>The image URL is intentionally broken</p>',
        image_url: 'https://this-domain-definitely-does-not-exist-12345.com/image.jpg',
        image_caption: 'This image will not load',
        start_page: 16,
        end_page: 16,
        location_in_start_page: { x: '55.0', y: '25.0' },
    },

    // Article with JavaScript in title (XSS attempt)
    {
        id: '23',
        type: 'article',
        title: '<script>alert("XSS")</script>Legitimate Title',
        author: '<img src=x onerror=alert("XSS")>',
        body: '<p onload="alert(\'XSS\')">Content with event handlers</p>',
        start_page: 17,
        end_page: 17,
        location_in_start_page: { x: '40.0', y: '60.0' },
    },

    // Article with CSS injection attempt
    {
        id: '24',
        type: 'article',
        title: 'Style Injection Test',
        body: '<style>body { display: none !important; }</style><p style="position:fixed;top:0;left:0;width:100%;height:100%;background:red;z-index:99999">CSS Injection</p>',
        start_page: 18,
        end_page: 18,
        location_in_start_page: { x: '50.0', y: '50.0' },
    },

    // Article with invalid page numbers
    {
        id: '25',
        type: 'article',
        title: 'Invalid page numbers',
        body: '<p>Start page is greater than end page</p>',
        start_page: 50,
        end_page: 25,
        location_in_start_page: { x: '20.0', y: '80.0' },
    },

    // Article with decimal page numbers
    {
        id: '26',
        type: 'article',
        title: 'Decimal page numbers',
        body: '<p>Testing non-integer page numbers</p>',
        start_page: 19.5,
        end_page: 20.7,
        location_in_start_page: { x: '65.0', y: '35.0' },
    },

    // Duplicate article IDs
    {
        id: '1', // Duplicate of first article
        type: 'article',
        title: 'Duplicate ID Test',
        body: '<p>This article has the same ID as article 1</p>',
        start_page: 21,
        end_page: 21,
        location_in_start_page: { x: '75.0', y: '25.0' },
    },

    // Article with all possible fields populated
    {
        id: '27',
        type: 'article',
        title: 'Complete Article with All Fields',
        pretitle: 'PRETITLE',
        subtitle: 'Subtitle text',
        author: 'Full Author Name',
        by_line: 'Complete Byline',
        body: '<p>Body content with <strong>formatting</strong></p>',
        image_url: 'https://example.com/image.jpg',
        image_caption: 'Full image caption',
        image_name: 'image_name.jpg',
        image_credit: 'Photo Credit',
        start_page: 22,
        end_page: 23,
        location_in_start_page: { x: '15.0', y: '15.0' },
        location_in_end_page: { x: '85.0', y: '85.0' },
        content_metrics: {
            total_number_of_words: 500,
            reading_time_minutes: 2,
            language: 'en',
            difficulty_level: 'medium',
        },
        metadata: {
            created_at: '2024-01-01T00:00:00Z',
            updated_at: '2024-01-02T00:00:00Z',
            version: 1,
            tags: ['test', 'complete', 'all-fields'],
            categories: ['testing', 'edge-cases'],
        },
        seo: {
            meta_title: 'SEO Title',
            meta_description: 'SEO Description',
            keywords: ['keyword1', 'keyword2'],
        },
    },

    // Performance stress: 1000 articles on same page
    ...Array.from({ length: 1000 }, (_, i) => ({
        id: String(1000 + i),
        type: 'article',
        title: `Stress Test Article ${i + 1}`,
        body: `<p>Article ${i + 1} of 1000 on the same page</p>`,
        start_page: 48,
        end_page: 48,
        location_in_start_page: {
            x: ((i % 10) * 10).toFixed(1),
            y: ((Math.floor(i / 10) % 10) * 10).toFixed(1),
        },
    })),
];
